var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificacionMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2.1 NotificacionMenu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FACTURACION",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.0.1-Perfil",
    transform: "translate(-1312.000000, -22.000000)",
    stroke: "#151916",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-NotificacionMenu",
    transform: "translate(1313.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,1.5 C8.16666667,1.5 9.83333333,1.5 11.5,1.5 C13.5,1.5 14.8333333,0.833333333 15.5,-0.5 L15.5,15.5 C14.8333333,14.1666667 13.5,13.5 11.5,13.5 C9.83333333,13.5 8.16666667,13.5 6.5,13.5 C3.1862915,13.5 0.5,10.8137085 0.5,7.5 C0.5,4.1862915 3.1862915,1.5 6.5,1.5 Z",
    id: "Rectangle-4",
    strokeLinejoin: "round",
    transform: "translate(8.000000, 7.500000) rotate(-270.000000) translate(-8.000000, -7.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,18 C8.1045695,18 9,17.1045695 9,16 C9,14.8954305 8.1045695,14 7,14",
    id: "Oval",
    transform: "translate(8.000000, 16.000000) rotate(-270.000000) translate(-8.000000, -16.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificacionMenu);
export default __webpack_public_path__ + "static/media/NotificacionMenu.8265bec217e57ec7616c8d66f887ccea.svg";
export { ForwardRef as ReactComponent };